<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import { ControlsContainer, Icon, Text } from '@Shelly/shelly-design-system';
	// Helpers
	import {
		getBillingDate,
		getEnabledHourControl,
		getInitLoadedPeriodStatistics,
		rangeDates,
		rangeOptions,
	} from './chart_control_helpers';
	import { getDiviceTimeZoneDate } from './chart_helper';
	import { deepCopy } from 'src/helpers/utilities';
	import { addonInputTypes } from 'src/helpers/addons/addon_helpers';
	import { mapIconToThin } from 'src/helpers/new-layout-helpers';
	// Components
	import Chart from './Chart.svelte';
	import ChartTitle from './ChartTitle.svelte';
	// Types
	import type { chartControlsDataInterface, rangeOptionInterface } from './chart_control_helpers';
	import type { Device } from '../../types/Device';
	import type {
		ChartConfig,
		ChartConfigInterface,
		StatisticsData,
		TimeZoneInterface,
	} from '../../types/Chart';
	import { getStatistics } from './chart_get_stats_period';
	import { isDistance, real_id } from 'src/helpers/interface_helpers';
	$: settingsStore = getDeviceSettings(device.id);
	export let device: Device, deviceChartsConfig: ChartConfigInterface[];

	let className = 'mb-s';
	export { className as class };

	const timeZone: TimeZoneInterface = getDiviceTimeZoneDate(device);
	const today = timeZone?.date || new Date();

	const chartsConfig: ChartConfigInterface = deviceChartsConfig[0],
		chartConfig: ChartConfig = chartsConfig?.charts?.[0],
		rangeControlOptions = deepCopy(rangeOptions);
	rangeControlOptions.find((a) => a.period == 'hour').enabled = getEnabledHourControl();
	const rangeOption: rangeOptionInterface = getInitLoadedPeriodStatistics(rangeControlOptions);
	const currentTime = rangeDates(
			rangeOption.period == 'billing_date' ? getBillingDate() : today,
			rangeOption,
			'init',
			!/^hour$/.test(rangeOption.period),
		),
		chartControlsData: chartControlsDataInterface = {
			time: currentTime,
			format: 'Y-m-d H:00:00',
			rangeOption,
			currentPeriod: rangeOption.period,
		},
		getStatsPeriod = async (
			chartControlsData: chartControlsDataInterface,
		): Promise<StatisticsData> => {
			return getStatistics(device, chartControlsData, chartConfig, chartsConfig.url);
		};

	let icon: string;
	if (chartConfig.name == 'consumption') {
		icon = mapIconToThin('fas fa-plug');
	} else if (chartConfig.name == 'ppm') {
		icon = mapIconToThin('fas fa-siren');
	} else if (chartConfig.name == 'counter_accumulation') {
		icon = mapIconToThin('far fa-gauge-circle-plus');
	} else if (chartConfig.name == 'freq_measurement') {
		icon = mapIconToThin('fas fa-wave-square');
	} else if (chartConfig.id == 'distance') {
		icon = mapIconToThin('fas fa-ruler-horizontal');
	} else {
		icon = mapIconToThin(addonInputTypes[chartConfig.name]?.icon || null);
	}

	const distanceUnit = device?.ht_ui?.unit || $settingsStore?.ht_ui?.unit || 'mm';
</script>

{#if chartConfig && !shouldHideLabelsAndCharts()}
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	{#await getStatsPeriod(chartControlsData) then result}
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div class={className} style="cursor: pointer;" on:click>
			<div style="pointer-events: none;">
				{#if isDistance(device.type)}
					<ControlsContainer color="color-0" size="s">
						<svelte:fragment slot="first">
							<Icon {icon} size="s" class="mb-s" />
							<ChartTitle
								styleType="h2"
								class="text-bold mb-s text-capitalize"
								title={chartConfig.title || chartConfig.name}
							/>
							<Text noWrap styleType="tiny"
								>{$format(`option_${rangeOption.period}`, {
									default: rangeOption.period,
								})}</Text
							>
							<Chart
								chartData={{
									...result.chartData,
									units: distanceUnit === 'in' ? 'in' : 'mm',
									type: 'areaspline',
								}}
								chartHeight={125}
								thumbMode
							/>
						</svelte:fragment>
					</ControlsContainer>
				{:else}
					<ControlsContainer color="color-0" size="s">
						<svelte:fragment slot="first">
							<Icon {icon} size="s" class="mb-s" />
							<ChartTitle
								styleType="h2"
								class="text-bold mb-s text-capitalize"
								title={chartConfig.title || chartConfig.name}
							/>
							<Text noWrap styleType="tiny"
								>{$format(`option_${rangeOption.period}`, {
									default: rangeOption.period,
								})}</Text
							>
							<Chart chartData={result.chartData} chartHeight={125} thumbMode />
						</svelte:fragment>
					</ControlsContainer>
				{/if}
			</div>
		</div>
	{:catch error}
		<!-- error.message -->
	{/await}
{/if}
